import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Flag, Limit, Policy, Vehicle } from "../../objects/policy";
import { QuoteService } from "../../services/quoteservice";
import { RatingResponse } from "../../objects/rating";
import { LookupService } from "../../services/lookupservice";
import { useSelector,useDispatch } from "react-redux";
import { Label } from "@mui/icons-material";
import {  TextField, FormControl, InputLabel, Select, MenuItem, Button, Snackbar,AlertColor,FormHelperText } from "@mui/material";
import Vehicles from "./Vehicles";
import CoverageLimitDropDown from "../../components/coverages/CoverageLimitDropDown";
import VehicleCoverageLimitDropDown from "../../components/coverages/VehicleCoverageLimitDropDown";
import { RatingService } from "../../services/ratingservice";
import {Backdrop,CircularProgress} from "@mui/material"
import dayjs from "dayjs";
import { logActivityAsync } from "../../objects/events/loadEvents";
import PolicyCoverageList from "../../components/coverages/PolicyCoverageList";
import JsonService from "../../services/jsonService";

export class CoverageChange {
    level: string ="";
    index: string = "";
    coverage:  string ="";
    limit: string = "";
}

export default function Coverages(props: any){
    var navigate = useNavigate();
    let quoteService = new QuoteService();
    let lookupService = new LookupService();
    let ratingService = new RatingService();

    const dispatch = useDispatch();

    const[policyNumber,setPolicyNumber] = useState<string>();
    const[policy, setPolicy] = useState<Policy>(new Policy());
    const[ratedQuote, setRatedQuote] = useState<RatingResponse>(new RatingResponse());
    const[ratedCoverages, setRatedCoverages] = useState<any>({});
    const[hasChanges, setHasChanges] = useState<boolean>(false);
    const[coverageChanges, setCoverageChanges] = useState<CoverageChange[]>([]);
    const[vehicles, setVehicles]=useState<Vehicle[]>([]);
    const[isOpenSpinner, setIsOpenSpinner] = useState<boolean>(false);
    const[policyCoverages, setPolicyCoverages] = useState<CoverageChange[]>([]);

    var policyStore = useSelector((state:any)=> state.policyReducer as Policy);
    var ratedPolicyStore = useSelector((state:any)=> state.ratedPolicyReducer as RatingResponse);
    
    const currencyFormatter = new Intl.NumberFormat('en-US',
    {
        style: 'currency',
        currency: 'USD'
    });

    useEffect(() => {
        (async () => {
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the coverages screen",
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
        })();
    }, [policy, policyNumber]);

    useEffect(()=> {
        setPolicy(policyStore);
        setRatedQuote(ratedPolicyStore);

        var limits = policyStore.limits.map((v:Limit, i: number)=>{
            var pcov= new CoverageChange();
            pcov.limit = v.limit;
            pcov.level = "POLICY";
            pcov.coverage = v.name;

            return pcov;
        });

        setPolicyCoverages(limits);

        var cVehicles = [...policyStore.vehicles];
        setVehicles(cVehicles);
        
        (async ()=>{
            var effectiveDate = policyStore.effectiveDate.replace("/", "-").replace("/", "-");
            var coverageResponse = await lookupService.GetCoverages(policyStore.ratedState, effectiveDate);

            if(!coverageResponse.ok){
                await logActivityAsync(policyStore?.policyNumber ?? "", {
                    recordKey: policyStore?.policyNumber,
                    transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                    action: "error_activity",
                    subject: "Coverages Screen - Fetch Coverages & Limits",
                    message: `Quote# ${policyStore?.policyNumber} - ${policyStore?.insuredFirstName} ${policyStore?.insuredLastName}, ${policyStore?.emailAddress ?? "NO EMAIL"}`,
                    isException: true,
                    error: coverageResponse?.error?.message ?? "Empty Response",
                    level: "ERROR",
                    isSent: false
                });

                var queryParams = new URLSearchParams(window.location.search);
                queryParams.set("returnUrl", "/");            
                navigate("/error?" + queryParams.toString());
            }


            
            setRatedCoverages(coverageResponse.data);
        })();
    },[policy, policyNumber])

    async function onGoBack(isSaveChanges: boolean) {
        if(hasChanges && isSaveChanges) {
            setIsOpenSpinner(true);
            var policyCoverages = coverageChanges.filter(m=> { return m.level == "POLICY"});
            var vehicleChanges =  coverageChanges.filter(m=> {return m.level == "VEHICLE"});

            var pclone = {...policy};
            var plimits = [...pclone.limits];
            
            policyCoverages.forEach((item:CoverageChange, index: number)=>{
                var currentLimit = plimits.find(m=>m.name == item.coverage);
                
                if(currentLimit!== undefined){
                    currentLimit.limit = item.limit;
                }else{
                    var newCov = {
                        type: "POLICY",
                        name: item.coverage,
                        limit: item.limit
                      }; 

                      plimits.push(newCov);
                }
            });

            pclone.limits = plimits;
            

            var vehiclesClone = [...pclone.vehicles];    

            vehicleChanges.forEach((item:CoverageChange, index:number)=>{
                var car = vehiclesClone.find(m=>m.vin == item.index);
                var carLimits = car?.coverageLimits.find(m=>m.name == item.coverage);

                if(carLimits!== undefined){
                    carLimits.limit = item.limit;
                }else{
                  var newCov = {
                    type: "VEHICLE",
                    carNumber: car?.carNumber,
                    name: item.coverage,
                    limit: item.limit
                  }; 

                  car?.coverageLimits.push(newCov);
                }
            });

            var response = await ratingService.Rate(pclone);

            if(response.ok){
                var data = await response.json();
                pclone.policyNumber = data.policyNumber;
                
                var serialize = await quoteService.serialize(pclone.policyNumber);
                var savedPolicy = serialize.data as Policy;
                

                setPolicyNumber(pclone?.policyNumber ?? "");
                setPolicy(savedPolicy);
                setRatedQuote(data);
                
                var limits = savedPolicy.limits.map((v:Limit, i: number)=>{
                    var pcov= new CoverageChange();
                    pcov.limit = v.limit;
                    pcov.level = "POLICY";
                    pcov.coverage = v.name;

                    return pcov;
                });

                setPolicyCoverages(limits);

                dispatch({type: "RATE_QUOTE", payload: data })
                dispatch({type: "UPDATE", payload: savedPolicy})

                setIsOpenSpinner(false);
                setHasChanges(false);

                
          
                
                //navigate("/coverages" + window.location.search);
            }else{
                var rateError = JsonService.parseObject(await response.text());
                await logActivityAsync(policy?.policyNumber ?? "", {
                    recordKey: policy?.policyNumber,
                    transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                    action: "error_activity",
                    subject: "Quote Screen - Fetch Rate Cycle",
                    message: `Quote# ${policy?.policyNumber} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                    isException: true,
                    error: rateError?.message ?? "Empty Response",
                    level: "ERROR",
                    isSent: false
                });

                setIsOpenSpinner(false);
                var errors = await response.json();
                var msg = errors.message.join(", ");

                setHasChanges(false);
            }

            
            setCoverageChanges([]);
            return;
        }

        navigate("/review" + window.location.search);
    }

    function onPolicyCoverageChange(coverage:any, limit:any, e:any){
        var updatedChanged = [...coverageChanges];
        var changeIndex = updatedChanged.findIndex(m=>m.level == "POLICY" && m.coverage == coverage);

        if(changeIndex>-1){
            updatedChanged.splice(changeIndex,1);
        }
        
        var change = new CoverageChange();
        change.coverage = coverage;
        change.index = "";
        change.level = "POLICY";
        change.limit = limit;

        updatedChanged.push(change)

        setHasChanges(true)
        setCoverageChanges(updatedChanged);
    }

    function onVehicleCoverageChange(vin: any, coverage:any, limit:any, e:any){

        var updatedChanged = [...coverageChanges];

        var changeIndex = updatedChanged.findIndex(m=>m.index == vin && m.coverage == coverage && m.level=="VEHICLE");
        var car = vehicles.find(m=>m.vin == vin);
        var currentCov = car?.coverageLimits.find(m=>m.name == coverage);

        if(changeIndex>-1){
            updatedChanged.splice(changeIndex,1);
        }
        
        var change = new CoverageChange();
        change.coverage = coverage;
        change.index = vin;
        change.level = "VEHICLE";
        change.limit = limit;

        updatedChanged.push(change)

        setHasChanges(true)
        setCoverageChanges(updatedChanged);
    }

    function renderConnectMessage(vehicle: Vehicle){
        var monitoringFlag = vehicle.flags.find((m:Flag) =>m.name == "MonitoringEnabled") as Flag;
        let isMonitoringEnabled = monitoringFlag == null ? false : monitoringFlag.hasFlag;

        return isMonitoringEnabled ? <>
        <span>
            Alset Insurance Perk!
            <br/>
            Your policy includes {vehicle.make} parts replacement on your {vehicle.make} vehicles
            <br/>
            AlsetConnect Enrollment Discount
        </span>
        </> : <></>;
    }

    return (
        <>
        <div className="container-quote pt-10 w-[85vw] sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw] ">
                <div className="grid grid-cols-12 gap-5">                

                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-12">
                        <h3 className="text-4xl font-bold">Coverages</h3>
                        <h4 className="mt-3 text-xl font-semibold mb-2">Policy Coverages</h4>  
                        <span className="text-gray-400 mt-2">Changes to the coverages below will apply to all vehicles on your policy</span>
                    </div>
                    

                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-12">
                        <div className="grid grid-cols-12 gap-5">
                        
                        <PolicyCoverageList policyNum={policyNumber} 
                            key={"PC123"} 
                            ratedCoverages={ratedCoverages} 
                            policyCoverages={policyCoverages} 
                            onPolicyCoverageChange={onPolicyCoverageChange} 
                            coverageChanges={coverageChanges}/>
                        </div>
                    </div>

                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-12">
                        <h4 className="mt-3 text-xl font-semibold mb-2">Vehicle Coverages</h4>  
                        <span className="text-gray-400 mt-2">Changes to the coverages below will apply to individual vehicles</span>
                    </div>

                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-12">
                        <div className="grid grid-cols-12 gap-5">
                        {
                            vehicles.map((v,i)=>{
                                return (
                                    <div className="col-span-12">
                                        <h4 className="text-gray-400 text-lg font-semibold">{v.year} {v.make} {v.model}</h4>
                                        <div className="grid grid-cols-12 gap-5">
                                        {
                                            (ratedCoverages?.distinctCoverages ?? []).map((v2: any,i2:any)=>{    
                                                
                                                var currentCoverage = v.coverageLimits.find(m=>m.name == v2.coverage);
                                                var vehicleCoverage = {...currentCoverage};

                                                var vehicleSelectedCoverage = coverageChanges.find((m:any)=>m.index == v.vin);

                                                var currentVehicleLimit = "";
                                                
                                                if(vehicleCoverage != undefined){
                                                    currentVehicleLimit = vehicleCoverage.limit;
                                                }

                                                if(vehicleSelectedCoverage!= undefined){
                                                    currentVehicleLimit = vehicleSelectedCoverage.limit;
                                                }

                                                if(vehicleSelectedCoverage == undefined && vehicleCoverage.limit === undefined){
                                                    currentVehicleLimit = v2.emptyLimit;
                                                }
                                                
                                                vehicleCoverage.emptyLimit = v2.emptyLimit;
                                           
                                                // var currentLimit = currentCoverage?.limit ?? "";        
                                                if(v2.isVehicleCoverage){
                                                    return (
                                                        <>
                                                        <VehicleCoverageLimitDropDown 
                                                            //key={v.vin +"_"+ v2.coverage}
                                                            key={`VL_${i2}`}
                                                            vin={v.vin}
                                                            lookupCoverages={(ratedCoverages.coverages ?? [])}
                                                            coverage={v2}
                                                            currentCoverage={vehicleCoverage}
                                                            currentLimit = {currentVehicleLimit}
                                                            onLimitChange={onVehicleCoverageChange}
                                                        />
                                                        </>
                                                    )
                                                }
                                            })

                                            
                                        }
                                        </div>
                                        <div className="grid grid-cols-1 pt-4">
                                            { renderConnectMessage(v) }
                                        </div>
                                    </div>
                                );
                            })
                        }
                        </div>
                    </div>

                  

                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-12">
                        <div className="bg-gray-200 rounded-md border-black border-4 pl-10 pr-10 pt-3 pb-3 w-full md:w-1/2 xl:w-1/2 2xl:w-1/2 m-auto text-center">
                            <span className="text-xl font-semibold">{currencyFormatter.format(ratedQuote.installments.find(m=>m.installmentNumber===1)?.totalDue ?? 0) } Due Per Month</span>
                            <br/>
                            <span className="text-gray-500">
                                {currencyFormatter.format(ratedQuote.totalWritten)} Total Premium
                            </span>
                        </div>

                        <div className="w-1/2 md:w-1/4 xl:w-1/4 2xl:w-1/4 pt-3 pb-3 mt-10 mb-10 m-auto">
                            <span className={ `${(hasChanges ? "bg-orange-200 hover:bg-orange-300" : "bg-gray-200 hover:bg-gray-300")} w-full block m-auto pt-3 pb-3 text-center rounded-md border-black border-4 hover:cursor-pointer`} 
                            onClick={()=>{onGoBack(true)}}>
                                {hasChanges ? "Recalculate" : "Go Back"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isOpenSpinner}
                onClick={()=>{}}>
                <CircularProgress color="inherit" />
            </Backdrop>

        </>
    );
}

